(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initPinnedStoryNotes(root) {
    if (root.dataset.psnInit === 'true') return;
    root.dataset.psnInit = 'true';

    var pinWrap = root.querySelector('[data-psn-pin-wrap]');
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-psn-note]'));
    var bgLayers = Array.prototype.slice.call(root.querySelectorAll('[data-psn-bg]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-psn-dot]'));

    if (!pinWrap || notes.length === 0) return;

    var stepCount = notes.length;

    function setActive(index) {
      var activeIndex = Math.max(0, Math.min(index, stepCount - 1));

      notes.forEach(function (note, i) {
        note.classList.toggle('is-active', i === activeIndex);
      });

      bgLayers.forEach(function (layer, i) {
        layer.classList.toggle('is-active', i === activeIndex);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });

      root.dataset.psnActive = String(activeIndex);
    }

    if (REDUCED_MOTION) {
      setActive(0);
      return;
    }

    function updateFromScroll() {
      var rect = pinWrap.getBoundingClientRect();
      var scrollable = pinWrap.offsetHeight - window.innerHeight;

      if (scrollable <= 0) {
        setActive(0);
        return;
      }

      var scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
      var progress = scrolled / scrollable;
      var index = Math.min(Math.floor(progress * stepCount), stepCount - 1);

      if (progress >= 0.999) {
        index = stepCount - 1;
      }

      setActive(index);
    }

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateFromScroll();
        ticking = false;
      });
    }

    setActive(0);
    updateFromScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-pinned-story-notes]').forEach(initPinnedStoryNotes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-pinned-story-notes]');
    if (section) initPinnedStoryNotes(section);
  });
})();
